/**
 * @fileoverview added by tsickle
 * Generated from: serializers/visit.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { dateField, dateTimeField, floatField, modelSerializer, serializerField } from '../util/serializers';
import { visit } from '../models/visit';
import { accountSerializer } from './account';
import { instructionSerializer } from './instruction';
import { jobSerializer } from './job';
import { keySerializer } from './key';
import { propertySerializer } from './property';
import { remoteKeyTransferSerializer } from './remote-key-transfer';
import { taskSerializer } from './task';
import { timeSlotSerializer } from './time-slot';
import { workerSerializer } from './worker';
/** @type {?} */
export var visitSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: visit,
    fields: {
        actual_date: dateField.create(),
        scheduled_date: dateField.create({ optional: true }),
        started_at: dateTimeField.create({ optional: true }),
        finished_at: dateTimeField.create({ optional: true }),
        customer_billed_for_skip_after: dateTimeField.create({ optional: true }),
        frequency: floatField.create({
            asString: true,
            optional: true
        }),
        account: (/** @type {?} */ (serializerField.create({
            serializer: accountSerializer,
            optional: true
        }))),
        estimated_start: (/** @type {?} */ (serializerField.create({
            serializer: timeSlotSerializer,
            optional: true
        }))),
        instructions: (/** @type {?} */ (serializerField.create({
            serializer: instructionSerializer,
            serializerKwargs: { many: true },
            optional: true
        }))),
        job: (/** @type {?} */ (serializerField.create({
            serializer: jobSerializer,
            optional: true
        }))),
        property: (/** @type {?} */ (serializerField.create({
            serializer: propertySerializer,
            optional: true
        }))),
        tasks: (/** @type {?} */ (serializerField.create({
            serializer: taskSerializer,
            serializerKwargs: { many: true },
            optional: true
        }))),
        time_slot: (/** @type {?} */ (serializerField.create({
            serializer: timeSlotSerializer,
            optional: true
        }))),
        week_beginning: dateField.create({
            optional: true
        }),
        workers: (/** @type {?} */ (serializerField.create({
            serializer: workerSerializer,
            serializerKwargs: { many: true },
            optional: true
        }))),
        required_keys: (/** @type {?} */ (serializerField.create({
            serializer: keySerializer,
            serializerKwargs: { many: true },
            optional: true
        }))),
        remote_key_transfers: (/** @type {?} */ (serializerField.create({
            serializer: remoteKeyTransferSerializer,
            serializerKwargs: { many: true },
            optional: true
        }))),
        recommended_start_time_slot: (/** @type {?} */ (serializerField.create({
            serializer: timeSlotSerializer,
            optional: true
        })))
    }
})))));
